import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  commitments: []
}

const mutations = {  
  SET_COMMITMENTS (state, payload) {
    state.commitments = payload
  },
  ADD_COMMITMENTS (state, payload) {
    state.commitments.push(payload)
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }
}

const actions = {
  getCommitment: (context, id) => {
    return Vue.http.get(`${env.API}/api/commitment/${id}`)    
      .then((response) => {        
        context.commit('SET_COMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  /*
  @data: {date: '<now>', id: '<userId>'}
  */
  getCommitmentByWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/commitment/by-week`, data)    
      .then((response) => {    
        // context.commit('SET_COMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createCommitment: (context, data) => {
    return Vue.http.post(`${env.API}/api/commitment`, data)    
    .then((response) => {    
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })   
  },
  deleteCommitment: (context, id) => {
    return Vue.http.delete(`${env.API}/api/commitment/remove/${id}`)    
      .then((response) => {    
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })   
  },
  commitmentById: (context, id) => {
    return Vue.http.get(`${env.API}/api/commitment/comments?${id}`)    
      .then((response) => {        
        context.commit('SET_COMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addCommentToCommitment: (context, data) => {
    return Vue.http.post(`${env.API}/api/commitment/comment`, data)    
      .then((response) => {        
        // context.commit('SET_COMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsFromCommitment: (context, id) => {
    return Vue.http.get(`${env.API}/api/commitment/comments/${id}`)
    .then(response => {
        return response.body.message
    })
    .catch(error => {
        return context.commit('API_FAILURE', error)
    })
  },
  addCommitmentToTracing: (context, data) => {
    return Vue.http.post(`${env.API}/api/commitment/to-tracing`, data)    
      .then((response) => {   
        context.commit('ADD_COMMITMENTS', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommitmentsByTracing: (context, id) => {
    return Vue.http.get(`${env.API}/api/commitment/tracing/${id}`)    
      .then((response) => {        
        context.commit('SET_COMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getPendingCommitmentsByTeam: (context, id) => {
    return Vue.http.get(`${env.API}/api/commitment/by-team/${id}`)
      .then(response => {
        context.commit('SET_COMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closeCommitment: (context, data) => {
    const { id, accomplished } = data
    return Vue.http.put(`${env.API}/api/commitment/close/${id}`, { accomplished })
    .then(response => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  }
}

const getters = {
  getCommitments: (state) => state.commitments
}

export const commitment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/commitment.js